import { TraitRegistryItem } from '../TraitRegistryItem';
export class TraitTypeCheckbox extends TraitRegistryItem {
    constructor(init) {
        super(init);
        Object.assign(this, init);
    }
}
